/* hc-recomatic-carousel — Enhance Recomatic widget with Embla Carousel */

(function () {
  'use strict';

  var HEADING_TEXT = 'You May Also Love';
  var BADGE_TEXT = 'BUY 1 GET 1 FREE';
  var EMBLA_CDN = 'https://unpkg.com/embla-carousel/embla-carousel.umd.js';
  var ENHANCE_TIMEOUT = 8000;
  var enhanced = false;

  var PREV_SVG =
    '<svg width="60" height="41" viewBox="0 0 61 41" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<rect width="60" height="40" rx="20" transform="matrix(-1 0 0 1 60.5 0.5)" stroke="currentColor"/>' +
    '<path d="M18.47 19.79a1 1 0 000 1.42l6.37 6.36a1 1 0 001.41-1.41L20.59 20.5l5.66-5.66a1 1 0 00-1.41-1.41l-6.37 6.36zM41.82 21.5a1 1 0 000-2v2zm-22.64 0h22.64v-2H19.18v2z" fill="currentColor"/>' +
    '</svg>';

  var NEXT_SVG =
    '<svg width="60" height="41" viewBox="0 0 61 41" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<rect x="0.5" y="0.5" width="60" height="40" rx="20" stroke="currentColor"/>' +
    '<path d="M42.53 19.79a1 1 0 010 1.42l-6.37 6.36a1 1 0 01-1.41-1.41l5.66-5.66-5.66-5.66a1 1 0 011.41-1.41l6.37 6.36zM19.18 21.5a1 1 0 010-2v2zm22.64 0H19.18v-2h22.64v2z" fill="currentColor"/>' +
    '</svg>';

  function loadEmbla() {
    return new Promise(function (resolve) {
      if (typeof EmblaCarousel !== 'undefined') {
        resolve();
        return;
      }
      var script = document.createElement('script');
      script.src = EMBLA_CDN;
      script.onload = resolve;
      script.onerror = function () {
        console.warn('[hc-recomatic-carousel] Failed to load Embla Carousel');
        resolve();
      };
      document.head.appendChild(script);
    });
  }

  function createHeader() {
    var header = document.createElement('header');
    header.className = 'hc-rc__header';

    var left = document.createElement('div');
    left.className = 'hc-rc__header-left';

    var title = document.createElement('h2');
    title.className = 'hc-rc__title';
    title.textContent = HEADING_TEXT;
    left.appendChild(title);

    var nav = document.createElement('nav');
    nav.className = 'hc-rc__nav';
    nav.setAttribute('aria-label', 'Carousel navigation');

    var prevBtn = document.createElement('button');
    prevBtn.className = 'hc-rc__nav-btn';
    prevBtn.setAttribute('aria-label', 'Previous');
    prevBtn.disabled = true;
    prevBtn.innerHTML = PREV_SVG;

    var nextBtn = document.createElement('button');
    nextBtn.className = 'hc-rc__nav-btn';
    nextBtn.setAttribute('aria-label', 'Next');
    nextBtn.innerHTML = NEXT_SVG;

    nav.appendChild(prevBtn);
    nav.appendChild(nextBtn);

    header.appendChild(left);
    header.appendChild(nav);

    return { el: header, prevBtn: prevBtn, nextBtn: nextBtn };
  }

  function createPagination() {
    var pagination = document.createElement('div');
    pagination.className = 'hc-rc__pagination';
    pagination.setAttribute('aria-label', 'Carousel pagination');
    return pagination;
  }

  function injectBadges(block) {
    var imageWraps = block.querySelectorAll('.recomatic-image-wrap');
    imageWraps.forEach(function (wrap) {
      if (wrap.querySelector('.hc-rc__badge')) return;
      var badge = document.createElement('span');
      badge.className = 'hc-rc__badge';
      badge.setAttribute('data-hc-sms-deal', '');
      badge.textContent = BADGE_TEXT;
      wrap.appendChild(badge);
    });
  }

  function removeInlineGridStyles(block) {
    var links = block.querySelectorAll('.recomatic-content');
    links.forEach(function (link) {
      link.style.removeProperty('grid-template-rows');
      link.style.removeProperty('display');
    });
  }

  function buildDots(container, embla) {
    if (!embla) return [];
    var snaps = embla.scrollSnapList();
    container.innerHTML = '';
    var dots = [];

    snaps.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'hc-rc__dot';
      dot.setAttribute('aria-label', 'Go to product group ' + (i + 1));
      dot.addEventListener('click', function () {
        embla.scrollTo(i);
      });
      container.appendChild(dot);
      dots.push(dot);
    });

    return dots;
  }

  function updateDots(dots, embla) {
    if (!embla || !dots.length) return;
    var selected = embla.selectedScrollSnap();
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === selected);
    });
  }

  function updateArrows(prevBtn, nextBtn, embla) {
    if (!embla) return;
    if (prevBtn) prevBtn.disabled = !embla.canScrollPrev();
    if (nextBtn) nextBtn.disabled = !embla.canScrollNext();
  }

  function enhance(block) {
    if (enhanced) return;
    enhanced = true;

    var container = block.querySelector('.recomatic-container');
    if (!container) return;

    block.classList.add('hc-rc-enhanced');

    removeInlineGridStyles(block);
    injectBadges(block);

    var header = createHeader();
    container.parentNode.insertBefore(header.el, container);

    var pagination = createPagination();
    container.parentNode.insertBefore(pagination, container.nextSibling);

    header.prevBtn.addEventListener('click', function () {
      if (block._embla) block._embla.scrollPrev();
    });
    header.nextBtn.addEventListener('click', function () {
      if (block._embla) block._embla.scrollNext();
    });

    loadEmbla().then(function () {
      if (typeof EmblaCarousel === 'undefined') return;

      var embla = EmblaCarousel(container, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: true,
        loop: false
      });

      block._embla = embla;
      var dots = buildDots(pagination, embla);

      embla.on('select', function () {
        updateDots(dots, embla);
        updateArrows(header.prevBtn, header.nextBtn, embla);
      });

      embla.on('reinit', function () {
        dots = buildDots(pagination, embla);
        updateDots(dots, embla);
        updateArrows(header.prevBtn, header.nextBtn, embla);
      });

      updateDots(dots, embla);
      updateArrows(header.prevBtn, header.nextBtn, embla);
    });
  }

  function tryEnhance() {
    var block = document.querySelector('.shopify-block-recomatic-product');
    if (!block) return false;

    var products = block.querySelector('.recomatic-products');
    var hasCards = products && products.querySelector('.recomatic-product');
    if (!hasCards) return false;

    enhance(block);
    return true;
  }

  if (tryEnhance()) return;

  var observer = new MutationObserver(function () {
    if (tryEnhance()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(function () {
    observer.disconnect();
    if (!enhanced) {
      var block = document.querySelector('.shopify-block-recomatic-product');
      if (block) block.style.visibility = 'visible';
    }
  }, ENHANCE_TIMEOUT);
})();
